import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap, delay } from 'rxjs/operators';
import { AppConfig } from '../app.config';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  isLoggedIn;
  ldapGroups: any[] = [];
  private user : string;
  constructor(private http: HttpClient) {
    if (localStorage.getItem('isAutenticatedUser') === 'true') {
      this.isLoggedIn = true
    } else {
      this.isLoggedIn = false
    }
  }
  // store the URL so we can redirect after logging in
  redirectUrl: string;

  login(userName: string, password: string): Observable<any> {
    let domain = AppConfig.settings.authUrl;
    let url = domain + '/login';
    this.user =  btoa(userName+':'+password);
    
    let headers  = new HttpHeaders({ 'Authorization': `Basic ${this.user}`});
     
    return this.http.get(url, {headers})
  }

  logout(): void {
    this.isLoggedIn = false;
  }

  setLdapGroups(ldapGroups:any[]) {
    this.ldapGroups = ldapGroups
  }

  getLdapGroups()  {
    return this.ldapGroups 
  }

  
}
